import { ApiResponse, TicketManagerTicketActionLog } from '@vision/ui/interfaces';
import { TicketManagerApi } from '../ticket-manager.api';
import { TicketManagerTicketActionLogsArgs } from './ticket-action-logs.api.types';
import {
  TicketManagerTicketActionLogResponseDto,
  normalizeTicketActionLogsResponse,
} from './ticket-action-logs.mappers';
import { buildTicketActionLogsRequest } from './ticket-action-logs.routes';

export const TicketActionLogsEndpoints = TicketManagerApi.injectEndpoints({
  endpoints: (builder) => ({
    ticketManagerTicketActionLogs: builder.query<
      ApiResponse<TicketManagerTicketActionLog[]>,
      TicketManagerTicketActionLogsArgs
    >({
      query: ({ projectId, ticketId }) => buildTicketActionLogsRequest({ projectId, ticketId }),
      transformResponse: (response: ApiResponse<TicketManagerTicketActionLogResponseDto[]>) =>
        normalizeTicketActionLogsResponse(response),
      providesTags: (_result, _error, { ticketId }) => [{ type: 'TicketManagerTicketActionLogs', id: ticketId }],
    }),
  }),
});

export const { useTicketManagerTicketActionLogsQuery } = TicketActionLogsEndpoints;
